import React, { useState, useEffect } from 'react';
import './GoogleReviews.css';
import translations from '../locale/fi.json';
import { FaStar, FaGoogle } from 'react-icons/fa';

const PLACE_ID = 'ChIJ21836rZaKUQRW1IoSTtGbCk';

// Karusellin yksi kopio täytetään vähintään tämän levyiseksi (px), jotta
// leveilläkään näytöillä ei näy tyhjää animaation aikana.
const MIN_COPY_WIDTH = 3840;
const ITEM_FULL_WIDTH = 530; // kortti 450px + 5rem väli

function GoogleReviews() {
    const [reviews, setReviews] = useState(null); // null = haku kesken
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        let cancelled = false;

        fetch('/api/reviews')
            .then(res => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
            .then(data => {
                if (cancelled) return;
                setReviews(data.reviews || []);
                if (data.rating) {
                    setSummary({ rating: data.rating, total: data.total });
                }
            })
            .catch(() => {
                if (!cancelled) setReviews([]);
            });

        return () => { cancelled = true; };
    }, []);

    const writeReviewLink = `https://search.google.com/local/writereview?placeid=${PLACE_ID}`;
    const allReviewsLink = `https://search.google.com/local/reviews?placeid=${PLACE_ID}`;

    // Listaa toistetaan kunnes yksi kopio on riittävän leveä, ja kopio
    // renderöidään kahdesti: -50 % translateX kiertää silloin saumattomasti.
    let marqueeReviews = [];
    if (reviews && reviews.length > 0) {
        const repeats = Math.ceil(MIN_COPY_WIDTH / (reviews.length * ITEM_FULL_WIDTH));
        const copy = Array(repeats).fill(reviews).flat();
        marqueeReviews = [...copy, ...copy];
    }

    return (
        <section className="reviews-section-clean">
            <div className="reviews-header">
                <h2 className="reviews-title-clean">{translations.home.reviews_title}</h2>
                {summary && (
                    <a
                        href={allReviewsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="google-rating-badge"
                    >
                        <FaGoogle />
                        <span className="google-rating-value">{summary.rating.toLocaleString('fi-FI')}</span>
                        <FaStar className="google-rating-star" />
                        <span>
                            {summary.total}{' '}
                            {summary.total === 1
                                ? translations.home.reviews_badge_suffix_singular
                                : translations.home.reviews_badge_suffix}
                        </span>
                    </a>
                )}
            </div>

            {marqueeReviews.length > 0 && (
                <div className="reviews-marquee-container-clean">
                    <div className="reviews-marquee-clean">
                        {marqueeReviews.map((review, index) => (
                            <div className="review-item-clean" key={index}>
                                <div className="stars-clean">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className={i < review.rating ? '' : 'star-empty'} />
                                    ))}
                                </div>
                                <p className="review-quote-clean">"{review.text}"</p>
                                <p className="review-author-clean">
                                    {review.author}
                                    {review.relativeTime && (
                                        <span className="review-time-clean">{review.relativeTime}</span>
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {reviews && reviews.length === 0 && (
                <p className="no-reviews-clean">{translations.home.no_reviews_yet}</p>
            )}

            <div className="leave-review-section-clean">
                <p className="leave-review-text-clean">{translations.home.leave_review_text}</p>
                <a
                    href={writeReviewLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-brand"
                >
                    <FaGoogle /> {translations.home.leave_review_button}
                </a>
            </div>
        </section>
    );
}

export default GoogleReviews;
